import React, { useContext, useEffect, useState } from "react";
// import Header from "../SharedComponents/Header";
// import Navbar from "../SharedComponents/Navbar";
import { ReactComponent as Rate } from "./../asset/icons/rate_header.svg";
import { ReactComponent as Person } from "./../asset/icons/person_v.svg";
import { ReactComponent as Light } from "./../asset/icons/light_r.svg";
import { ReactComponent as Time } from "./../asset/icons/time_v.svg";
import { ReactComponent as Star } from "./../asset/icons/star_m.svg";
import { ReactComponent as Message } from "./../asset/icons/message_b.svg";
import { ReactComponent as Compare } from "./../asset/icons/compare-icon.svg";
import { ReactComponent as Share } from "./../asset/icons/share_c.svg";
import { ReactComponent as Rocket } from "./../asset/icons/rocket_e.svg";
import { ReactComponent as Comment } from "./../asset/icons/comment-icon.svg";
import { ReactComponent as Forum } from "./../asset/icons/forum-icon.svg";
import { ReactComponent as CloseIcon } from "./../asset/icons/closeWhite.svg";
import { ReactComponent as CoinIcon } from "./../asset/icons/coin.svg";
import { ReactComponent as Details } from "./../asset/icons/details-icon.svg";

import ScanImage from "./../asset/image/home_scan.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./style.scss";
import { GlobalStateContext } from "../layouts/GlobalStates";
import MainPanelHeader from "./../layouts/mainPanelHeader/index";
import SidebarMenu from "./../layouts/sidebarMenu/index";
import InstallAppModal from "../component/global/installAppModal";
import { getProduct } from "../feedback/universalData";
import { getAjax } from "../feedback/axiosMethods";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import StarRatings from "react-star-ratings";

export default function MainDashboard() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [installAppModalShow, setInstallAppModalShow] = useState(false);
    const [product, setProduct] = useState();
    const { t, i18n } = useTranslation();
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;

    const desktopRedirector = () => {
        navigate("/dashboard/");
    };

    useEffect(() => {
        return () =>
            window.removeEventListener("resize", desktopRedirector, true);
    }, []);

    useEffect(() => {
        if (id) {
            sessionStorage.setItem("product-id", id);
        } else {
            sessionStorage.removeItem("product-id");
        }
    }, [id]);

    useEffect(() => {
        desktopRedirector();
        window.addEventListener("resize", desktopRedirector, true);

        return () =>
            window.removeEventListener("resize", desktopRedirector, true);
    }, []);

    useEffect(() => {
        let deferredPrompt;
        const addBtn = document.querySelector(".add-button");
        // addBtn.style.display = "none";

        window.addEventListener("beforeinstallprompt", (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;
            // Update UI to notify the user they can add to home screen
            if (window.sessionStorage.getItem("showMeLater") !== "1")
                setInstallAppModalShow(true);

            addBtn?.addEventListener("click", (e) => {
                // hide our user interface that shows our A2HS button
                setInstallAppModalShow(false);
                // Show the prompt
                deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === "accepted") {
                    } else {
                        console.log("User dismissed the A2HS prompt");
                    }
                    deferredPrompt = null;
                });
            });
        });
    }, []);

    useEffect(() => {
        if (id) {
            getAjax(getProduct.replace(":id", id), i18n.language).then((r) => {
                // if (!r) return;
                const criteria_replies = r.form.criteria_list.map((r) => {
                    return {
                        criteria: r.id,
                        state: undefined, //(r.criteria_state_type === 2 || r.criteria_state_type === 3) ? undefined : 0,
                        description: "",
                    };
                });
                setResult({
                    data: {
                        ...result.data,
                        form: r.form.id,
                        item: r.item.id,
                        company: r.item.company,
                        criteria_replies,
                    },
                    ajax: r,
                    productId: id,
                });
                // setProduct({
                //     title: r.item.item_type_name,
                //     name: r.item.name,
                //     score: r.item.computed_score,
                //     count: r.item.feedback_count,
                // });
                // console.log(r);
            });
        }
    }, [i18n.language]);

    useEffect(() => {
        if (!id) {
            setResult({
                ...result,
                data: {
                    first_name: "",
                    last_name: "",
                    score: 0,
                    phone_number: "",
                    criteria_replies: [],
                    form: 0,
                    item: 0,
                    features: [],
                },
                ajax: [],
                productId: "",
                username: "",
            });
        }
    }, []);

    const printButtonsHandle = () => {
        if (id) {
            return (
                <>
                    <Link to={`/feedback/${id}`}>
                        <div className="menu-item menu-2">
                            <div>
                                <Details />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Product.Detail.Label")}
                            </div>
                        </div>
                    </Link>

                    <Link to={`/feedback/form/${id}`}>
                        <div className="menu-item menu-6">
                            <div>
                                <Comment />
                            </div>
                            <div>{t("Src.Dashboard.index.Comment.Label")}</div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link>
                    <Link to={`/feedback/more/${id}`}>
                        <div className="menu-item menu-3">
                            <div>
                                <Light />
                            </div>
                            <div>{t("Src.Dashboard.index.Idea.Label")}</div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link>
                    <Link to={`/feedback/share-product/${id}`}>
                        <div className="menu-item menu-8">
                            <div>
                                <Share />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Introduce.Label")}
                            </div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link>

                    {/* <Link to={`/${id}`}>
                        <div className="menu-item menu-11 soon">
                            <div>
                                <Compare />
                            </div>
                            <div>{t("Src.Dashboard.index.Compare.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to={`/${id}`}>
                        <div className="menu-item menu-12 soon">
                            <div>
                                <Forum />
                            </div>
                            <div>{t("Src.Dashboard.index.Forum.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to={`/${id}`}>
                        <div className="menu-item menu-1 soon">
                            <div>
                                <Rate />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Feed.Coin.Label")}
                            </div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link> */}

                    {/* <Link to={`/${id}`}>
                        <div className="menu-item menu-5 soon">
                            <div>
                                <Star />
                            </div>
                            <div>{t("Src.Dashboard.index.Best.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link> */}
                </>
            );
        } else {
            return (
                <>
                    <Link to="/dashboard/messages/user">
                        <div className="menu-item menu-6">
                            <div>
                                <Message />
                            </div>
                            <div>{t("Src.Dashboard.index.Messages.Label")}</div>
                        </div>
                    </Link>
                    <Link to="/dashboard/user/customer-club">
                        <div className="menu-item menu-2">
                            <div>
                                <Person />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Customer.Club.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to="/dashboard/user/discount">
                        <div className="menu-item menu-4">
                            <div>
                                <Time />
                            </div>
                            <div>{t("Src.Dashboard.index.Discount.Label")}</div>
                        </div>
                    </Link>
                    {/* <Link to={`/feedback/more/0`}>
                        <div className="menu-item menu-3">
                            <div>
                                <Light />
                            </div>
                            <div>{t("Src.Dashboard.index.Idea.Label")}</div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link> */}
                    {/* <Link to={`/feedback/more/${id}`}>
                        <div className="menu-item menu-3">
                            <div>
                                <Light />
                            </div>
                            <div>{t("Src.Dashboard.index.Idea.Label")}</div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link>
                    <Link to={`/feedback/share-product/${id}`}>
                        <div className="menu-item menu-8">
                            <div>
                                <Share />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Introduce.Label")}
                            </div>
                            <div className="coin">
                                <CoinIcon />
                                <span>2</span>
                            </div>
                        </div>
                    </Link> */}
                    {/* <Link to="/">
                        <div className="menu-item menu-11 soon">
                            <div>
                                <Compare />
                            </div>
                            <div>{t("Src.Dashboard.index.Compare.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to="/">
                        <div className="menu-item menu-12 soon">
                            <div>
                                <Forum />
                            </div>
                            <div>{t("Src.Dashboard.index.Forum.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to="/">
                        <div className="menu-item menu-1 soon">
                            <div>
                                <Rate />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Feed.Coin.Label")}
                            </div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>

                    <Link to="/">
                        <div className="menu-item menu-3 soon">
                            <div>
                                <Light />
                            </div>
                            <div>{t("Src.Dashboard.index.Idea.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>

                    <Link to="/">
                        <div className="menu-item menu-5 soon">
                            <div>
                                <Star />
                            </div>
                            <div>{t("Src.Dashboard.index.Best.Label")}</div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>

                    <Link to="/">
                        <div className="menu-item menu-8 soon">
                            <div>
                                <Share />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Introduce.Label")}
                            </div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link>
                    <Link to="/">
                        <div className="menu-item menu-10 soon">
                            <div>
                                <Rocket />
                            </div>
                            <div>
                                {t("Src.Dashboard.index.Product.Ads.Label")}
                            </div>
                            <div className="soon-div">
                                {t("Src.Dashboard.index.Soon.Label")}
                            </div>
                        </div>
                    </Link> */}
                </>
            );
        }
    };
    const isQRCodeUser = (id) => {
        const value = id * 1;
        const isNumber = typeof value === "number" && isFinite(value);
        console.log(id, value, isNumber);
        return !isNumber;
    };

    return (
        <React.Fragment>
            {/* <Header /> */}
            <SidebarMenu />
            <div className="home-container">
                <MainPanelHeader />
                <div
                    className="home-scan-card"
                    onClick={(_) => !id && navigate("/scanner")}
                >
                    {!id && (
                        <>
                            <img src={ScanImage} alt="" />
                            <div>
                                <h2>
                                    {t(
                                        "Src.Dashboard.index.Scan.Product.Label"
                                    )}
                                </h2>
                                <p>{t("Src.Dashboard.index.Qr.Scan.Label")}</p>
                                {/* <div className="scan-btn">
                                    <button>
                                        <Arrow />
                                    </button>
                                </div> */}
                            </div>
                        </>
                    )}
                    {id && result.ajax?.item?.id && (
                        <>
                            {/* <img src={ScanImage} alt="" /> */}
                            <div className="information-box">
                                <div className="header-section">
                                    <h2>
                                        {isQRCodeUser(id)
                                            ? result.ajax.item.name
                                            : result.ajax.item.item_type_name}
                                    </h2>
                                    <button onClick={() => navigate("/")}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="rating-stars-con">
                                    <div
                                        dir="ltr"
                                        style={{
                                            transform:
                                                i18n.dir() === "rtl"
                                                    ? "scaleX(-1)"
                                                    : "",
                                        }}
                                    >
                                        <StarRatings
                                            starRatedColor="rgb(254, 183, 48)"
                                            starEmptyColor="#ccc"
                                            rating={
                                                result.ajax.item.computed_score
                                            }
                                            starDimension="30px"
                                            starSpacing="2px"
                                            svgIconViewBox="0 0 32 32"
                                            svgIconPath="M 24.49994659423828 28.95012855529785 C 24.3575267791748 28.95013999938965 24.21438789367676 28.92934989929199 24.07449722290039 28.88831901550293 L 17.04545783996582 26.82704925537109 C 16.81686782836914 26.76001930236816 16.58017730712891 26.72602844238281 16.34195709228516 26.72602844238281 C 16.10373687744141 26.72602844238281 15.86704730987549 26.76001930236816 15.63845729827881 26.82705879211426 L 8.609416961669922 28.88831901550293 C 8.46955680847168 28.9293384552002 8.326407432556152 28.95012855529785 8.183937072753906 28.95012855529785 C 7.37572717666626 28.95012855529785 6.704487323760986 28.29068946838379 6.687637329101563 27.4801197052002 L 6.542447090148926 20.49673843383789 C 6.531887054443359 19.98868942260742 6.36951732635498 19.50203895568848 6.072886943817139 19.08940887451172 L 1.987167119979858 13.40614891052246 C 1.706327080726624 13.01549911499023 1.629837036132813 12.52879905700684 1.777297139167786 12.07082939147949 C 1.924757122993469 11.61286926269531 2.270867109298706 11.26223945617676 2.726886987686157 11.10884952545166 L 9.559877395629883 8.810439109802246 C 10.02445697784424 8.654169082641602 10.4296875 8.367519378662109 10.73174667358398 7.981479167938232 L 15.16060733795166 2.321199178695679 C 15.44685745239258 1.955369234085083 15.87743663787842 1.745549201965332 16.34195709228516 1.745549201965332 C 16.80647659301758 1.745549201965332 17.23705673217773 1.955369234085083 17.52330780029297 2.321199178695679 L 21.95216751098633 7.981459140777588 C 22.25423622131348 8.367519378662109 22.65946769714355 8.654169082641602 23.12403678894043 8.810439109802246 L 29.9570369720459 11.10884952545166 C 30.41304779052734 11.26223945617676 30.75915718078613 11.61286926269531 30.9066162109375 12.07082939147949 C 31.0540771484375 12.52879905700684 30.97758674621582 13.01549911499023 30.69674682617188 13.40614891052246 L 26.61103630065918 19.08940887451172 C 26.31441688537598 19.50200843811035 26.15203666687012 19.98864936828613 26.14146614074707 20.49672889709473 L 25.99627685546875 27.48012924194336 C 25.97942733764648 28.2906494140625 25.30817794799805 28.95008850097656 24.49994659423828 28.95012855529785 Z"
                                        />
                                    </div>
                                    <div className="text-section">
                                        <span>
                                            {Math.round(
                                                result.ajax.item
                                                    .computed_score * 100
                                            ) / 100}
                                        </span>{" "}
                                        ({result.ajax.item.feedback_count}{" "}
                                        {t(
                                            "Src.Dashboard.index.Comment.Count.Label"
                                        )}
                                        )
                                    </div>
                                </div>
                                <p>
                                    {isQRCodeUser(id)
                                        ? result.ajax.item.description
                                        : result.ajax.item.name}
                                </p>

                                {/* <div className="scan-btn">
                                    <button>
                                        <Arrow />
                                    </button>
                                </div> */}
                            </div>
                        </>
                    )}
                    {id && !result.ajax?.item?.id && (
                        <>
                            <Spinner animation="border" />
                        </>
                    )}
                </div>
                <div className="home-menu-container">
                    {printButtonsHandle()}
                </div>
                <InstallAppModal
                    show={installAppModalShow}
                    onHide={() => setInstallAppModalShow(false)}
                    onReject={() =>
                        window.sessionStorage.setItem("showMeLater", 1)
                    }
                />
            </div>
            {/* <Navbar /> */}
        </React.Fragment>
    );
}
